import React, { Component } from 'react';
import AMS from '@ui/components/ams';
import { pushPageViewEvent } from '@lib/atm';
import { withServerSideProps } from '@lib/withServerSideProps';
import { seasonalPageQuery } from '@queries/pages/seasonal';
import Page from '@ui/components/ams/Pages/Page';

const PAGE_NAME = 'promotions';

class SeasonalPage extends Component {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
      pageData,
    } = this.props;

    const [{
      pageTitle: title,
      slug,
    }] = pageData.seasonalPage;

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        title,
        sections: [PAGE_NAME, slug],
      },
    );
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
      locale,
    } = this.props;

    const {
      seasonalPage = [],
      pageAds = [],
    } = pageData;

    const seasonalPageData = seasonalPage.length ? seasonalPage[0] : {};
    const googleAdToDisplay = pageAds && (pageAds[0] || null);

    const {
      pageTitle,
      metaDescription,
    } = seasonalPageData;

    return (
      <Page
        analyticsPageName={PAGE_NAME}
        pageTitle={pageTitle}
        metaDescription={metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
        pageAds={pageAds}
      >
        <AMS.SeasonalContent
          urlLocale={locale}
          seasonalPageData={seasonalPageData}
          userData={userSessionData.userData}
          googleAd={googleAdToDisplay}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: seasonalPageQuery,
  getPageQueryVariables: ({ query: { seasonalSlug } }) => ({
    seasonalSlug,
  }),
});

export default SeasonalPage;
